export default {
    getUserData: (state) => {
        return state.userData
    }
}
